import { render, staticRenderFns } from "./KoreksiForm.vue?vue&type=template&id=4b187db6&"
import script from "./KoreksiForm.vue?vue&type=script&lang=js&"
export * from "./KoreksiForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/jqwidgets/jqx.base.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports